import React from "react";
import { withTheme } from "styled-components";
import Flex from "@irati/ui/src/Flex";
import { Label } from "@irati/ui/src/Typography";
var OldAmount = function (_a) {
    var value = _a.value, theme = _a.theme;
    return (React.createElement(Flex, { padding: theme.spacing.oneAndHalf + " 0px", direction: "column", justifyContent: "flex-end" },
        React.createElement(Label, { large: true, textDecoration: "line-through" }, value + "%")));
};
export default withTheme(OldAmount);
